import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import ContactFilters from "./_filters";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import { confirmAlert } from 'react-confirm-alert';
import { showLoader } from "../../../components/loader/loader";
import { ButtonTableDelete, ButtonTableEdit } from "../../../components/buttons/buttonsActions";
import { contactCategoryService } from "../../../jwt/_services/xailing/contactCategoryService";
import { FL_TITLE } from "../../../components/i18n/formLabels";
import {
    ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, LB_ACTIONS, LB_ACTIVE,
    LB_CODE,  LB_EMPTY_TABLE, LIST, NO, YES
} from "../../../components/i18n/i18n";

const ContacCategoryList = ({ setForm, app }) => {
    const [fbDataBaseId] = useState(app?.fbDataBase?.id);
    const [udn] = useState(localStorage.getItem('selectedUdn') === 'undefined' ? null : JSON.parse( localStorage.getItem('selectedUdn') ));
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false)

    //Bootstraptable
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [totalSize, setTotalSize] = useState(10);
    const [currentIndex, setCurrentIndex] = useState(0);

    //Place items
    const [listItems, setListItems] = useState([]);

    const [dataFilter, setDataFilter] = useState({
        udn	: { id : udn.id },
        code   : null,
        status : null
    });

    useEffect(() => refreshDataList(page, currentIndex, sizePerPage, dataFilter), []);

    const refreshDataList = (page, currentIndex, sizePerPage, _dataFilters) => {
        setLoading(true);

        contactCategoryService.search(currentIndex, sizePerPage, _dataFilters)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.total);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }

                setLoading(false);
            })
    }

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage,dataFilter);
    };

    const confirmDelete = (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{ARE_YOU_SHURE_MSG}</p>
            <button onClick={ onClose }>{ NO }</button>
            <button className="btn-alert-delete"
                    onClick={() => {
                        deleteItem(data)
                        onClose();
                    }}
            >
                { YES }
            </button>
        </div>
    });

    const deleteItem = (data) => {
        setLoading(true);

        contactCategoryService.deleteItem(data.id, fbDataBaseId)
            .then(data => {
                    setLoadData(!loadData)
                    refreshDataList(page, currentIndex, sizePerPage, dataFilter);
                }
            )
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        setForm(true, itemToEdit, "FORM");
    }

    const handleStatusChange = async (id, data, status) => await contactCategoryService.updateItem(id, {
        fbDataBase:  { id : fbDataBaseId },
        item: { ...data, status:status, id:id }
    })

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'code',
            text: `${LB_CODE}`,
            headerStyle: {width: '300px'},
        }, {
            dataField: 'title',
            text: `${FL_TITLE}`
        }, {
            dataField: 'status',
            text: `${LB_ACTIVE}`,
            headerStyle: {width: '80px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell, row) => <GenericSwitch
                id={ row?.id }
                initialState={ row?.status }
                onChange={ handleStatusChange }
            />
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerStyle: {width: '200px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell, row) => <>
                <ButtonTableEdit onClick={() => editItem(row)}/>
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
            </>
        }
    ];

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDataList(page, currentIndex, sizePerPage, _dataFilter);
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{LIST}
            </CardTitle>

            <ContactFilters refreshFiltered={refreshFiltered} />

            <CardBody className="">
                { loading && showLoader() }
                <BootstrapTable
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={ listItems }
                    columns={ columns }
                    noDataIndication={ LB_EMPTY_TABLE }
                    pagination={ paginationFactory({page, sizePerPage, totalSize}) }
                    onTableChange={ handleTableChange }
                />
            </CardBody>
        </Card>
    )
}

export default ContacCategoryList